import { faPhoneAlt } from "@fortawesome/pro-solid-svg-icons/faPhoneAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useCountryValue } from "../Contexts/CountryContext";
import * as HostStates from "../Types/HostStateTypes";
function CallToActionText(host) {
  var state = useCountryValue()[0];
  var ddi = host.ddi,
    status = host.status;
  if (status === HostStates.INCOMING) {
    return /*#__PURE__*/React.createElement("h3", {
      className: "numberline"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faPhoneAlt
    }), " Ich werde gerade verbunden");
  }
  if (status === HostStates.CONNECTED) {
    return /*#__PURE__*/React.createElement("h3", {
      className: "numberline"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faPhoneAlt
    }), " Ich telefoniere gerade");
  }
  if (status === HostStates.FREE) {
    var phoneInfo = state.callData.countries[state.country];
    var landline = phoneInfo.number,
      mobile = phoneInfo.mobileNumber,
      mobileExtension = phoneInfo.mobileNumberExtension;
    switch (state.country) {
      case "de":
        if (state.device === 'phone') {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
            className: 'button',
            href: "tel:" + landline + ddi,
            target: '_top'
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faPhoneAlt
          }), "\u00A0", landline, " ", /*#__PURE__*/React.createElement("span", {
            className: "ddi"
          }, ddi, "*")), /*#__PURE__*/React.createElement("p", null, "Ruf mich an und frage nach meinem Livecam\u2011Code:"));
        } else {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
            className: 'button',
            href: "tel:" + mobile,
            target: '_top'
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faPhoneAlt
          }), "\u00A0", mobile, "*"), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, mobileExtension, ddi)), /*#__PURE__*/React.createElement("p", null, "Ruf an und gib die PIN durch, du wirst dann mit mir verbunden.", /*#__PURE__*/React.createElement("br", null), "Frage mich dann nach meinem Livecam\u2011Code:"));
        }
      case "ch":
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
          className: 'button',
          href: "tel:" + landline,
          target: '_top'
        }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faPhoneAlt
        }), "\u00A0", landline), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
          className: "highlight2"
        }, /*#__PURE__*/React.createElement("strong", null, 'PIN: ' + ddi))), /*#__PURE__*/React.createElement("p", null, "Ruf an und folge den Anweisungen des Systems, tippe dann die ", /*#__PURE__*/React.createElement("span", {
          className: 'highlight2'
        }, "PIN"), " ein:"));
      case "at":
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
          className: 'button',
          href: "tel:" + landline + ddi,
          target: '_top'
        }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faPhoneAlt
        }), "\u00A0", landline, " ", /*#__PURE__*/React.createElement("span", {
          className: "ddi"
        }, ddi, "*")), /*#__PURE__*/React.createElement("p", null, "Ruf mich an und frage nach meinem Livecam\u2011Code:"));
    }
  }
  return null;
}
export default CallToActionText;